import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'layer',
} as IModuleProps;
